
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temple-pos",
      function () {
        return require("private-next-pages/temple-pos.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temple-pos"])
      });
    }
  